module.exports = __webpack_public_path__ + "img/twbgsch_icon.025f67c8.png";